import React from "react";
import { Dropdown, Option } from "@campgladiator/cgui-core.atoms.dropdown";
import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import { setInitialValueIfOnlyOneOption } from "../../utils";
import styles from "./SelectCouponInput.module.scss";

export type SelectCouponInputProps = {
  couponOptions: Option[];
  handleSelectCouponOption: (option?: Option) => void;
  isDisabled?: boolean;
};

const SelectCouponInput = ({
  couponOptions,
  handleSelectCouponOption,
  isDisabled,
}: SelectCouponInputProps) => (
  <>
    <Paragraph size="small" className={styles.label}>
      Discount Code
    </Paragraph>
    <Dropdown
      options={setInitialValueIfOnlyOneOption(couponOptions)}
      disabled={!couponOptions.length || isDisabled}
      onChangeSelectedOption={handleSelectCouponOption}
    />
  </>
);

export default SelectCouponInput;
